<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <tab-item icon="info-circle" heading="Step 1" subheading="Details"></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Details</strong>
                <p class="muted">Enter the general details of this project here.</p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">

                  <b-form-group label="Title" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.title.$error }">
                    <b-form-input v-model="form.title" type="text" required maxlength="500" :class="{ 'form-control': true, 'is-invalid': $v.form.title.$error }"></b-form-input>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.title.$error">You must enter a title.</span>
                  </b-form-group>

                  <b-form-group label="PI / Lead" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.primaryInvestigatorId.$error }">
                    <autocomplete :source="usersApi"
                                  :inputClass="{ 'form-control': true, 'is-invalid': $v.form.primaryInvestigatorId.$error }"
                                  resultsValue="asurite"
                                  :resultsDisplay="userDisplay"
                                  ref="piAutocomplete"
                                  @selected="selectUser"
                                  credentials="include"
                                  :request-headers="requestHeaders"
                                  ></autocomplete>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.primaryInvestigatorId.$error">You must enter a name.</span>
                  </b-form-group>

                  <b-form-group label="Type" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.projectTypeId.$error }">
                    <b-form-select :options="types" v-model="form.projectTypeId" text-field="name" value-field="id" :class="{ 'form-control': true, 'is-invalid': $v.form.projectTypeId.$error }"></b-form-select>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.projectTypeId.$error">You must select a type.</span>
                  </b-form-group>

                  <b-form-group label="Is this project funded?" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      id="radio-group-1"
                      v-model="form.funded"
                      :options="fundedOptions"
                      :aria-describedby="ariaDescribedby"
                      name="funded-radio-options"
                    ></b-form-radio-group>
                  </b-form-group>

                  <b-form-group label="Funding Source" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.projectFundingSourceId.$error }">
                    <b-form-select :options="sources" v-model="form.projectFundingSourceId" text-field="name" value-field="id" :class="{ 'form-control': true, 'is-invalid': $v.form.projectFundingSourceId.$error }">
                      <template slot="first"><option :value="null">None</option></template>
                    </b-form-select>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.projectFundingSourceId.$error">You must select a source.</span>
                  </b-form-group>

                  

                  <b-form-group label="Location" label-class="control-label form-label">
                    <b-form-input v-model="form.location" type="text" maxlength="500"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Start Date" label-class="control-label form-label">
                    <datepicker v-model="form.startDate"
                              class="top"
                              :inputClass="{ 'form-control': true }"
                              :typeable="true"
                              format="MM/dd/yyyy"></datepicker>
                  </b-form-group>

                  <b-form-group label="End Date" label-class="control-label form-label">
                    <datepicker v-model="form.endDate"
                              class="top"
                              :inputClass="{ 'form-control': true }"
                              :typeable="true"
                              format="MM/dd/yyyy"></datepicker>
                  </b-form-group>
                  
                  <b-form-group label="Status" label-class="control-label form-label" :class="{ 'invalid-group': $v.form.statusId.$error }">
                    <b-form-select :options="statuses" v-model="form.statusId" text-field="name" value-field="id" :class="{ 'form-control': true, 'is-invalid': $v.form.statusId.$error }"></b-form-select>
                    <span class="span-feedback invalid-feedback" v-if="$v.form.statusId.$error">You must select a type.</span>
                  </b-form-group>


                   

                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item icon="file-alt" heading="Step 2" subheading="Description"></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Description</strong>
                <p>Enter the project description here.</p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">

                  <b-form-group label="Description" label-class="control-label form-label">
                    <vue-editor id="descriptionEditor" v-model="description"></vue-editor>
                  </b-form-group>

                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-button variant="primary" class="pull-right my-2" @click="submit()"><font-awesome-icon icon="check" /> Submit</b-button>
  </div>
</template>
<script>
var htmlEncode = require("js-htmlencode").htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;
import TabItem from "../../components/menu/tab-item";
import Autocomplete from "../../components/autocomplete";
import Datepicker from "vuejs-datepicker";
import { required, maxLength } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import * as _ from "lodash";

export default {
  name: "ProjectForm",
  data() {
    return {
      fundedOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      description: null,
      form: {
        id: 0,
        title: null,
        description: null,
        primaryInvestigatorId: null,
        projectTypeId: null,
        location: null,
        startDate: null,
        endDate: null,
        statusId: null,
        projectFundingSourceId: null,
        funded: false
      },
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },
  props: {
    item: {
      type: Object,
      required: false
    },
    statuses: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    },
    sources: {
      type: Array,
      required: true
    }
  },
  components: {
    VueEditor,
    TabItem,
    Autocomplete,
    Datepicker
  },
  validations() {
    var validations = {
      form: {
        title: {
          required,
          maxLength: maxLength(500)
        },
        primaryInvestigatorId: { required },
        projectTypeId: { required },
        statusId: { required },
        projectFundingSourceId: {}
      }
    };

    if (this.form.funded) {
      validations.form.projectFundingSourceId = { required };
    }

    return validations;
  },
  computed: {
    usersApi: function() {
      // return process.env.VUE_APP_BASE_URI + "/api/users/findldap?search=";
      return process.env.VUE_APP_BASE_URI + "/api/employees/search?search=";
    }
  },
  methods: {
    userDisplay: function(user) {
      // var uDept = user.department ? " " + user.department : "";

      var uDescr =
        user.employeeJobs.length > 0
          ? " - " +
            user.employeeJobs[0].department.description +
            " - " +
            user.employeeJobs[0].title
          : "";

      return (
        user.firstName +
        " " +
        user.lastName +
        " (" +
        user.asuriteId + ")" +
        // user.department +
        // " - " +
        // user.title
        uDescr
      );
    },
    selectUser: function(autoselectResponse) {
      var user = autoselectResponse.selectedObject;
      this.form.primaryInvestigatorId = user.asuriteId;
    },
    submit: function() {
      this.$v.form.$touch();

      if (!this.$v.form.$error) {
        if (this.description) {
          this.form.description = htmlEncode(this.description);
        }
        this.$emit("submit", this.form);
      }
    },
    loadForm(item) {
      if (item) {
        this.form = _.clone(item);
        if (this.form.description) {
          this.description = htmlDecode(this.form.description);
        }

        this.$refs.piAutocomplete.display =
          this.form.primaryInvestigator.firstName +
          " " +
          this.form.primaryInvestigator.lastName +
          " (" +
          this.form.primaryInvestigatorId +
          ")";
      }
    }
  },
  watch: {
    item: function() {
      if (this.item) {
        this.loadForm(this.item);
      }
    }
  }
};
</script>
<style>
.top .vdp-datepicker__calendar {
  position: absolute;
  top: -282px;
}
.bottom .vdp-datepicker__calendar {
  position: absolute;
  top: 33px;
}
</style>
